import React, {useState} from 'react'
import { Editor } from '@tinymce/tinymce-react';

const Tinymce = props => {

  const [content, setContent] = useState(props.content)

  return <div style={{width: '79%', marginLeft: '20%'}}>
    <input type="hidden" name={props.name} value={content} />
    <Editor
     tinymceScriptSrc="/tinymce/tinymce.min.js"
     apiKey="akkadfn2r13cdt4d89n2v9o78m2wgdl383vkon4h8v2wkfvg"
     initialValue={props.content}
     init={{
       height: props.height,
       menubar: false,
       sandbox_iframes: false,
       formats: {
          imageCaption: { inline: 'span', classes: 'image_caption' }
        },
        style_formats: [
          { title: 'potpis slike', format: 'imageCaption' }
      ],
       plugins: [
         'image', 'link', 'code', 'lists', 'advlist', 'wordcount', 'media', 'help',

       ],
       // content_css: '/tinymce_custom.css',
       quickbars_selection_toolbar: 'bold italic | quicklink blockquote',
       quickbars_insert_toolbar: false,
       quickbars_image_toolbar: false,
       toolbar:
         props.extended ?
         'undo redo | cut copy paste | styleselect bold italic blockquote | bullist numlist | link anchor | image media | visualblocks code help'
         :
         'undo redo | cut copy paste | styleselect bold italic blockquote | bullist numlist | image media link | code help'
     }}
     onEditorChange={(editorContent) => setContent(editorContent)}
   />
   </div>
}
export default Tinymce
